import { defineStore } from 'pinia'

export const useProductHistoryStore = defineStore('productHistory', {
  state: () => ({
    showtip: true
  }),
  actions: {
    updateShowTip (value) {
      this.showtip = value
    }
  }
})
